const accordions = document.querySelectorAll('.m-accordion');

if (accordions) {
  accordions.forEach((accordion) => {
    const accordionRows = Array.from(accordion.children);

    accordionRows.forEach((row) => {
      row.addEventListener('click', () => {
        if (row.classList.contains('open')) {
          row.classList.remove('open');
        } else {
          accordionRows.forEach((r) => {
            r.classList.remove('open');
          });
          setTimeout(() => {
            row.classList.add('open');
          }, 500);
        }
      });
    });
  });
}
